import { getAppConfig } from '@bts-web/core-app-config';
import {
  TradeControllerVariants,
  TradeScreenTranslations,
  isBpfsAsset,
} from '../../../utils';
import { AssetType } from '../../../../asset-details/types';
import {
  MutableNonNullableAsset,
  TradeInnerTranslatedValues,
} from '../../types';

export const getTranslationsPerTradeType = ({
  translations,
  variant,
  assetType,
  isRealStock,
}: {
  assetType: MutableNonNullableAsset['__typename'];
  translations: TradeScreenTranslations;
  variant: TradeControllerVariants;
  isRealStock?: boolean;
}) => {
  const isBpfs = isBpfsAsset(assetType as AssetType);

  const { currency } = getAppConfig();

  const poweredByText = isBpfs
    ? translations.poweredByBpfs
    : translations.poweredByTenant;

  const currencyTranslation =
    translations[
      currency.toLocaleLowerCase() as keyof TradeScreenTranslations
    ] || '';

  const translatedInnerValues: TradeInnerTranslatedValues = {
    poweredByText,
    isMax: translations.max,
    verifyInfoText: translations.verifyTradeInfo ?? 'NA',
    tradeButtonText:
      variant === 'buy' ? translations.buyNow : translations.sellNow,
    verifyButtonText: translations.actionButtonVerifyText ?? 'NA',
    startPushTan: translations.startPushTan ?? 'NA',
    authenticationRequiredTitle:
      translations.authenticationRequiredTitle ?? 'NA',
    grams: translations.grams ?? 'NA',
    inclSpread: translations.inclSpread ?? 'NA',
    market: translations.market ?? 'NA',
    selectorLabels: {
      fiat: currencyTranslation,
      asset:
        assetType === AssetType.METAL
          ? translations.grams?.toUpperCase?.() // we need the uppercase variant from translations
          : translations.units,
    },

    confirmButtonText: isRealStock
      ? translations.reviewOrder
      : translations.actionButtonText,
    percentage100: translations.percentage100,
    percentage75: translations.percentage75,
    percentage50: translations.percentage50,
    percentage25: translations.percentage25,
    percentageMinus1: translations.percentageMinus1,
    percentageMinus5: translations.percentageMinus5,
    percentageMinus10: translations.percentageMinus10,
    percentagePlus1: translations.percentagePlus1,
    percentagePlus5: translations.percentagePlus5,
    percentagePlus10: translations.percentagePlus10,
  };

  return { translatedInnerValues };
};
